import React from "react";

const VendorsModule = React.lazy(() => import("./ui/Vendors"));

export const VendorsPage = () => {
  return <VendorsModule />;
};
